import React from 'react';

const SvgPh = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="PH_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="PH_svg__b" fill="#fff">
        <use xlinkHref="#PH_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path
        d="M0 20l13.333-10-.889-.667H28V20H0z"
        fill="#DD1C34"
        mask="url(#PH_svg__b)"
      />
      <path
        d="M0 0h28v9.333H12.444L0 0z"
        fill="#0D4BC3"
        mask="url(#PH_svg__b)"
      />
      <path
        d="M4.532 11.327l-1.14 1.753.432-2.047a1.341 1.341 0 0 1-.19-.19l-2.047.433 1.753-1.141a1.35 1.35 0 0 1 0-.27l-1.753-1.14 2.046.432c.057-.07.121-.133.19-.19L3.392 6.92l1.141 1.753a1.35 1.35 0 0 1 .27 0l1.14-1.753-.432 2.047c.07.057.133.12.19.19l2.046-.433-1.753 1.141a1.35 1.35 0 0 1 0 .27l1.753 1.14-2.046-.432c-.057.07-.12.133-.19.19l.432 2.047-1.14-1.753a1.35 1.35 0 0 1-.27 0zm5.468-.66a.667.667 0 1 1 0-1.334.667.667 0 0 1 0 1.334zM2 4a.667.667 0 1 1 0-1.333A.667.667 0 0 1 2 4zm0 13.333A.667.667 0 1 1 2 16a.667.667 0 0 1 0 1.333z"
        fill="#FDD64D"
        mask="url(#PH_svg__b)"
      />
    </g>
  </svg>
);

export default SvgPh;
